/** I tipi di socio, per come consumano. Vedi `MemberType`. */
export const MEMBER_TYPES = [
	{ value: 'residential' as const, label: 'Famiglia', icon: '🏠' },
	{ value: 'office' as const, label: 'Ufficio', icon: '🏢' },
	{ value: 'shop' as const, label: 'Negozio', icon: '🛍️' },
	{ value: 'sme' as const, label: 'Impresa', icon: '🔧' },
	{ value: 'factory' as const, label: 'Fabbrica', icon: '🏭' },
	{ value: 'public_administration' as const, label: 'Ente pubblico', icon: '🏛️' },
	{ value: 'ets' as const, label: 'Associazione', icon: '🤝' },
];

export const MEMBER_ROLES = [
	{ value: 'consumer' as const, label: 'Consumatore' },
	{ value: 'producer' as const, label: 'Produttore' },
	{ value: 'prosumer' as const, label: 'Prosumer' },
];

export const MEMBER_STATUSES = [
	{ value: 'verified' as const, label: 'Completo', color: 'green' },
	{ value: 'incomplete' as const, label: 'Incompleto', color: 'orange' },
	{ value: 'pending' as const, label: 'In Attesa', color: 'blue' },
	{ value: 'takeover' as const, label: 'Subentro', color: 'purple' },
	{ value: 'withdrawn' as const, label: 'Receduto', color: 'muted' },
];
